import * as React from "react"

import { cn } from "@/lib/utils"
import { Label } from "./label"

function Field({ className, children, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("flex flex-col space-y-1", className)} {...props}>
      {children}
    </div>
  )
}

function FieldGroup({ className, children, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("grid gap-4", className)} {...props}>
      {children}
    </div>
  )
}

function FieldLabel(props: React.ComponentProps<typeof Label>) {
  return <Label {...props} />
}

function FieldDescription({ className, ...props }: React.ComponentProps<"p">) {
  return <p className={cn("text-sm text-muted-foreground", className)} {...props} />
}

export { Field, FieldGroup, FieldLabel, FieldDescription }
